/* eslint-disable @typescript-eslint/no-explicit-any */
import { FabricObject } from 'fabric';

import { Marker } from '../../metaBullets/classes/Marker';
import { TextEntity } from '../../metaBullets/classes/TextEntity';

/**
 * Проверяет, является ли объект маркером
 */
export const isMarker = (obj: FabricObject | undefined | null): obj is Marker => {
  if (!obj) return false;
  return obj.type === 'marker' && !!(obj as any).isMarker;
};

/**
 * Проверяет, является ли объект текстовой сущностью (используем статический метод)
 */
export const isTextEntityObject = (obj: FabricObject | undefined | null): obj is TextEntity => {
  if (!obj) return false;
  return TextEntity.isTextEntity(obj);
};

/**
 * Проверяет, есть ли в массиве объектов хотя бы один маркер
 */
export const hasMarkerInObjects = (objects: FabricObject[]): boolean => {
  return objects.some((obj) => isMarker(obj));
};

/**
 * Проверяет, все ли объекты в массиве являются текстовыми сущностями
 */
export const areAllTextEntities = (objects: FabricObject[]): boolean => {
  return objects.length > 0 && objects.every((obj) => isTextEntityObject(obj));
};

/**
 * Проверяет, есть ли в массиве объектов хотя бы одна текстовая сущность
 */
export const hasTextEntityInObjects = (objects: FabricObject[]): boolean => {
  return objects.some((obj) => isTextEntityObject(obj));
};
